module.exports = "/assets/packs/images/b448ca94f764cedf5cef32fe077df33c.jpg";